/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, {
  useState, useEffect, useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem, SubMenu } from 'rc-menu';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';

import { useTheme } from 'emotion-theming';
import Text from '../../../../shared/components/Text/Text';
import HeaderSubMenuPopup from './HeaderSubMenuPopup';
import 'rc-dropdown/assets/index.css';

import iconSet from '../../../../shared/images/teambuildr-selection.json';
import {
  setGroupByFilter,
  setSelectedDaysOfWeekToShowInCurrentWeek,
  setSelectedNumberOfDaysToShowInWeek,
  setSelectedWeekViewDayToggle,
  setViewType,
} from '../../ducks/calendarActions';
import usePreSaveNavigationGuard from '../../hooks/usePreSaveNavigationGuard';
import themedScrollbar from './themedScrollbar';
import useIsMobile from '../../../../shared/hooks/useIsMobile';

const DropdownContainer = styled('div')`
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 4px 8px;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.buttonBackground};

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.borderButton};
  /* Shadow/Theme/20 */
  box-shadow: 0 1px 3px 0 rgba(48, 49, 51, 0.10), 0 0 1px 0 rgba(48, 49, 51, 0.05);

  @media screen and (max-width: 570px) {
    padding: 2px 6px;
    span, p {
      font-size: 13px !important;
    }
  }
`;

/* The menu renders in rc-dropdown's portal. Emotion's theme still reaches it
   through context, so these read props.theme; the colour props remain for
   callers that need an explicit override. */
const MenuWrapper = styled('div')`
  .custom-rc-menu {
    border-radius: 4px !important;
    box-shadow: 0px 4px 8px 0px #3031331A !important;
    border: 1px solid ${(props) => props.theme.colors.borderLight} !important;
    background-color: ${(props) => props.theme.colors.surface} !important;

    padding-top: 8px;
    padding-bottom: 8px;
    
    ${themedScrollbar}
  }

  /* No rule for rc-menu's -active class: the app drives keyboard focus itself
   * (isHighlighted, inline), and rc-menu marks every item active when they
   * share an eventKey -- which painted whole menus grey. */
  .rc-menu-item:hover,
  .rc-menu-item-selected,
  .rc-menu-submenu-title:hover {
    background-color: ${(props) => props.theme.colors.surfaceSecondary} !important;
  }

  .rc-menu-submenu-title {
    padding: 0px !important;
  }

  .rc-menu-submenu-arrow {
    display: none;
  }

`;

const CustomDivider = styled.div`
  height: 1px;
  margin: 8px 0;
  background-color: ${(props) => props.theme.colors.borderLight};

  margin-left: 10px;
  margin-right: 10px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

const HoverableMenuItem = ({
  hoverableItem,
}) => {
  const [openKeys, setOpenKeys] = useState([]);
  const [subMenuVisible, setSubMenuVisible] = useState(false);
  const calendarContainerScrollPosition = useSelector((state) => state.calendar.data.calendarContainerScrollPosition);

  useEffect(() => {
    /** close select menu if main container is scrolled */
    if (subMenuVisible) {
      setSubMenuVisible(false);
    }
  }, [calendarContainerScrollPosition]);

  useEffect(() => {
    const handleWindowChange = () => {
      if (subMenuVisible) {
        setSubMenuVisible(false);
      }
    };

    window.addEventListener('resize', handleWindowChange);
    window.addEventListener('scroll', handleWindowChange);

    return () => {
      window.removeEventListener('resize', handleWindowChange);
      window.removeEventListener('scroll', handleWindowChange);
    };
  }, [subMenuVisible]);

  const handleOpenChange = (keys) => {
    /** Only allow one submenu to be open at a time */
    if (keys.length > 1) {
      setOpenKeys([keys[keys.length - 1]]); /** Keep only the most recently opened */
    } else {
      setOpenKeys(keys);
    }
  };

  const [isHovered, setIsHovered] = useState(false);
  const { colors } = useTheme();

  const disabled = false;
  const menuItemContent = (
    <div
      style={{
        display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center', position: 'relative',
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', gap: hoverableItem.shortcut === 'superset' ? '0px' : '8px', cursor: disabled && 'not-allowed',
      }}
      >
        <IcomoonReact
          iconSet={iconSet}
          size={hoverableItem.shortcut === 'superset' ? 24 : 16}
          icon={hoverableItem.icon}
          color={disabled ? colors.textTertiary : (hoverableItem.color || colors.textSecondary)}
        />
        {hoverableItem.extra}
        <Text
          fontSize='16px'
          color={disabled ? colors.textTertiary : colors.text}
        >
          {hoverableItem.label}
        </Text>
      </div>
      {hoverableItem.isChecked !== undefined && hoverableItem.isChecked && (
        <IcomoonReact iconSet={iconSet} size={16} icon='checkmark' color={disabled ? colors.textDisabled : colors.text} />
      )}
      {hoverableItem.hasSubmenu
        ? <IcomoonReact iconSet={iconSet} size={10} icon='altrightarrow' color={colors.textSecondary} />
        : <Text color={colors.text}>{hoverableItem.shortcut}</Text>}
    </div>
  );

  if (hoverableItem.hasSubmenu) {
    return (
      <Menu
        triggerSubMenuAction='click'
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        style={{
          border: 'none',
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
          margin: 0,
        }}
        className='nested-submenu'
      >
        <div onClick={() => setSubMenuVisible(true)}>
          <SubMenu
            key={hoverableItem.key}
            title={(
              <div style={{
                paddingTop: 7,
                paddingBottom: 7,
                paddingLeft: 16,
                paddingRight: 16,
                cursor: hoverableItem.disabled ? 'not-allowed' : 'pointer',
                background: isHovered ? colors.surfaceSecondary : colors.surfaceElevated,
              }}
              >
                {menuItemContent}
              </div>
        )}
            onTitleMouseEnter={() => setIsHovered(true)}
            onTitleMouseLeave={() => setIsHovered(false)}
            popupClassName={
            `${hoverableItem.shortcut === 'superset' ? 'custom-submenu-supersetPicker' : 'pace-dropdown'}${!subMenuVisible ? ' custom-submenu-supersetPicker-displayNone' : ''}`
            }
          >
            <MenuItem key={`${hoverableItem.key}-popup`} style={{ padding: 0 }}>
              {(hoverableItem.shortcut === 'Start Week On' || hoverableItem.shortcut === 'Number of Days' || hoverableItem.shortcut === 'Show' || hoverableItem.shortcut === 'Group By') && (
                <HeaderSubMenuPopup
                  left={0}
                  top={0}
                  openTop={false}
                  spaceAbove={null}
                  menuType={hoverableItem.shortcut}
                />
              )}
            </MenuItem>
          </SubMenu>
        </div>
      </Menu>
    );
  }

  return (
    <MenuItem
      key={hoverableItem.key}
      /* rc-menu only turns a React key into an eventKey for direct children
       * of <Menu>. Rendered through this wrapper, every item got eventKey
       * undefined, so activating one activated all of them. */
      eventKey={hoverableItem.key}
      style={{
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 16,
        paddingRight: 16,
        boxShadow: 'none',
        cursor: hoverableItem.disabled ? 'not-allowed' : 'pointer',
        background: isHovered ? colors.surfaceSecondary : 'transparent',
      }}
      onClick={hoverableItem.disabled ? null : (e) => hoverableItem.action(e)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <IconContainer>
        {menuItemContent}
      </IconContainer>
    </MenuItem>
  );
};

HoverableMenuItem.propTypes = {
  hoverableItem: PropTypes.shape({
    key: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    action: PropTypes.func,
    extra: PropTypes.node,
    isChecked: PropTypes.bool,
    shortcut: PropTypes.string,
    hasSubmenu: PropTypes.bool,
  }).isRequired,
};

HoverableMenuItem.defaultProps = {
};

const HeaderDropdownMenu = () => {
  const [localDropdownVisible, setLocalDropdownVisible] = useState(false);
  const dispatch = useDispatch();
  const guardNavigation = usePreSaveNavigationGuard();
  /** Month view isn't practical on phones - hide the option on very small
  screens (useIsMobile mirrors the app-wide 480px media-query breakpoint and
  only re-renders when the threshold is crossed). */
  const isVerySmallScreen = useIsMobile();
  const [maxDropdownHeight, setMaxDropdownHeight] = useState(500);
  const dropdownRef = useRef(null);
  const programType = useSelector((state) => state.calendar.data.programType);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const calendarContainerScrollPosition = useSelector((state) => state.calendar.data.calendarContainerScrollPosition);
  const selectedWeekViewDayToggle = useSelector(
    (state) => state.calendar.data.selectedWeekViewDayToggle,
  );
  const selectedReduxCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const selectedReduxNonDateBasedProgram = useSelector(
    (state) => state.calendar.data.selectedReduxNonDateBasedProgram,
  );
  const selectedNumberOfDaysToShowInWeek = useSelector(
    (state) => state.calendar.data.selectedNumberOfDaysToShowInWeek,
  );
  const selectedDaysOfWeekToShowInCurrentWeek = useSelector(
    (state) => state.calendar.data.selectedDaysOfWeekToShowInCurrentWeek,
  );
  const groupByFilter = useSelector(
    (state) => state.calendar.data.groupByFilter,
  );
  const nonDateBasedProgramItems = useSelector((state) => state.calendar.data.nonDateBasedProgramItems);

  const hasMounted = useRef(false);
  const { colors } = useTheme();

  const lastWeekNumberInProgram = React.useMemo(() => {
    const items = Array.isArray(nonDateBasedProgramItems)
      ? nonDateBasedProgramItems
      : Object.values(nonDateBasedProgramItems || {});

    return items.reduce(
      (max, item) => Math.max(max, item.weekNumber),
      0,
    );
  }, [nonDateBasedProgramItems]);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    const handleResize = () => {
      if (localDropdownVisible) {
        setLocalDropdownVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [localDropdownVisible]);

  useEffect(() => {
    if (localDropdownVisible) {
      setLocalDropdownVisible(false);
    }
  }, [calendarContainerScrollPosition]);

  useEffect(() => {
    /** reset filters */
    dispatch(setSelectedNumberOfDaysToShowInWeek(7));
    dispatch(setSelectedWeekViewDayToggle('Everyday'));
    dispatch(setSelectedDaysOfWeekToShowInCurrentWeek(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Empty Days', 'Weekends']));
    dispatch(setGroupByFilter('Week'));
  }, [
    programType,
    viewType,
  ]);

  useEffect(() => {
    if (groupByFilter === 'Day') {
      dispatch(setSelectedNumberOfDaysToShowInWeek(selectedReduxNonDateBasedProgram.numberOfWeeks));
    }
    if (groupByFilter === 'Week') {
      dispatch(setSelectedNumberOfDaysToShowInWeek(7));
    }
  }, [
    groupByFilter,
    selectedReduxNonDateBasedProgram,
  ]);

  /** logic to close the dropdown when window scroll horizontally */
  useEffect(() => {
    let scrollTimeout = null;
    let didScroll = false;

    const handleScroll = () => {
      if (localDropdownVisible && !didScroll) {
        setLocalDropdownVisible(false); /** close on first scroll */
        didScroll = true;
      }

      /** Reset scroll state after scroll stops */
      if (scrollTimeout !== null) {
        clearTimeout(scrollTimeout);
      }

      scrollTimeout = setTimeout(() => {
        didScroll = false;
      }, 200);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout !== null) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [localDropdownVisible]);

  const menuItems = [
    {
      key: '1',
      label: 'Day',
      action: () => guardNavigation(() => dispatch(setViewType('dayView'))),
      isChecked: viewType === 'dayView',
      inActive: false,
    },
    {
      key: '2',
      label: 'Week',
      action: () => guardNavigation(() => dispatch(setViewType('weekView'))),
      isChecked: viewType === 'weekView',
      inActive: false,
    },
    {
      key: '3',
      label: 'Month',
      action: () => guardNavigation(() => dispatch(setViewType('monthView'))),
      isChecked: viewType === 'monthView',
      inActive: programType === 'free-form-program' || isVerySmallScreen,
    },
    {
      divider: true,
      inActive: viewType === 'dayView'
      || viewType === 'monthView'
      || (programType === 'calendar' && !Object.keys(selectedReduxCalendar).length && !Object.keys(selectedReduxAthlete).length)
      || (programType === 'free-form-program' && !Object.keys(selectedReduxNonDateBasedProgram).length),
    },
    {
      key: '4',
      label: 'Start Week On',
      action: () => {},
      shortcut: 'Start Week On',
      inActive: true,
      hasSubmenu: true,
    },
    {
      key: '5',
      label: 'Number of Days',
      action: () => {},
      shortcut: 'Number of Days',
      // inActive: programType === 'free-form-program' || viewType === 'dayView' || (!Object.keys(selectedReduxCalendar).length && !Object.keys(selectedReduxAthlete).length),
      inActive: viewType === 'dayView'
      || viewType === 'monthView'
      || (programType === 'calendar' && !Object.keys(selectedReduxCalendar).length && !Object.keys(selectedReduxAthlete).length)
      || (programType === 'free-form-program' && !Object.keys(selectedReduxNonDateBasedProgram).length),
      hasSubmenu: true,
    },
    {
      key: '6',
      label: 'Show',
      action: () => {},
      shortcut: 'Show',
      inActive: programType === 'free-form-program' || viewType === 'dayView' || viewType === 'monthView' || selectedWeekViewDayToggle !== 'Everyday' || (!Object.keys(selectedReduxCalendar).length && !Object.keys(selectedReduxAthlete).length),
      hasSubmenu: true,
    },
    {
      key: '7',
      label: 'Group By',
      action: () => {},
      shortcut: 'Group By',
      inActive: programType === 'calendar' || viewType === 'dayView' || viewType === 'monthView' || (!Object.keys(selectedReduxNonDateBasedProgram).length),
      hasSubmenu: true,
    },
  ];

  const isNumberOfDaysFilterActive = () => {
    let numberOfDaysFilterSelected;
    if (programType === 'free-form-program') {
      numberOfDaysFilterSelected = selectedNumberOfDaysToShowInWeek < (groupByFilter === 'Day' ? lastWeekNumberInProgram : 7);
    } else {
      /** Both Everyday and the weekday-toggle sliding window cap at 7 */
      numberOfDaysFilterSelected = selectedNumberOfDaysToShowInWeek < 7;
    }

    return !!numberOfDaysFilterSelected;
  };

  const numberOfActiveFiltersForDaysToShow = () => {
    if (selectedWeekViewDayToggle !== 'Everyday') {
      return 0;
    }
    return 9 - selectedDaysOfWeekToShowInCurrentWeek?.length;
  };

  const totalNumberOfActiveFilters = () => (numberOfActiveFiltersForDaysToShow() + (isNumberOfDaysFilterActive() ? 1 : 0));

  const renderMenuItems = () => menuItems.map((item, renderIndex) => {
    if (item.inActive) return null;

    if (item.divider) return <CustomDivider key={`divider-${renderIndex}`} dividerColor={colors.borderLight} />;

    return (
      <HoverableMenuItem hoverableItem={item} key={item.key} isNumberOfDaysFilterActive={isNumberOfDaysFilterActive()} numberOfActiveFiltersForDaysToShow={numberOfActiveFiltersForDaysToShow()} />
    );
  });

  return (
    <Dropdown
      trigger={['click']}
      overlay={(
        <MenuWrapper
          onClick={(e) => e.stopPropagation()}
        >
          <Menu
            triggerSubMenuAction='click'
            className='custom-rc-menu'
            style={{
              width: 195,
              minHeight: 100,
              /** minus 20 for a bit of padding */
              maxHeight: maxDropdownHeight - 20,
              overflowY: 'auto',
              marginBottom: '0px',
              border: `1px solid ${colors.borderLight}`,
              background: colors.surfaceElevated,
            }}
          >
            {renderMenuItems()}
          </Menu>
        </MenuWrapper>
      )}
      visible={localDropdownVisible}
      onVisibleChange={(visible) => {
        setLocalDropdownVisible(visible);
        if (visible) {
          const dropdownIcon = dropdownRef.current.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const calculatedMaxHeight = windowHeight - dropdownIcon.top - 25;
          const maxHeight = dropdownIcon.top - 100 > calculatedMaxHeight ? dropdownIcon.top - 25 : calculatedMaxHeight;
          setMaxDropdownHeight(maxHeight);
        }
      }}
    >
      <DropdownContainer ref={dropdownRef}>
        <Text>{viewType === 'weekView' ? 'Week' : viewType === 'monthView' ? 'Month' : 'Day'}</Text>
        <IcomoonReact
          iconSet={iconSet}
          size={10}
          icon='downarrowalt2'
          color={colors.textSecondary}
        />
        {viewType === 'weekView' && (totalNumberOfActiveFilters() > 0 || (programType === 'free-form-program' && groupByFilter !== 'Week')) && (
        <IcomoonReact
          iconSet={iconSet}
          size={16}
          icon='info2'
          style={{
            position: 'absolute', right: -8, top: -10, background: colors.surfaceElevated,
          }}
        />
        )}
      </DropdownContainer>
    </Dropdown>
  );
};

HeaderDropdownMenu.defaultProps = {
};

HeaderDropdownMenu.propTypes = {
};

export default HeaderDropdownMenu;
